import { TenantEntity } from '../TenantEntity'

export class MAWB extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get sequence() {
    return this._data.sequence
  }
  set sequence(sequence) {
    this._data.sequence = sequence || 0
  }
  get carrierId() {
    return this._data.carrierId
  }
  set carrierId(carrierId) {
    this._data.carrierId = carrierId || 0
  }
  get bookingAgentId() {
    return this._data.bookingAgentId
  }
  set bookingAgentId(bookingAgentId) {
    this._data.bookingAgentId = bookingAgentId || 0
  }
  get startNo() {
    return this._data.startNo
  }
  set startNo(startNo) {
    this._data.startNo = startNo
  }
  get number() {
    return this._data.number
  }
  set number(number) {
    this._data.number = number || 0
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark
  }
  get inputBy() {
    return this._data.inputBy
  }
  set inputBy(inputBy) {
    this._data.inputBy = inputBy || 0
  }
  get dep() {
    return this._data.dep
  }
  set dep(dep) {
    this._data.dep = dep || 0
  }
  get inputDate() {
    return this._data.inputDate
  }
  set inputDate(inputDate) {
    this._data.inputDate = inputDate
  }
  get effectDate() {
    return this._data.effectDate
  }
  set effectDate(effectDate) {
    this._data.effectDate = effectDate
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }
  get batchAddNo() {
    return this._data.batchAddNo
  }
  set batchAddNo(batchAddNo) {
    this._data.batchAddNo = batchAddNo || ''
  }
}
